import styled from 'styled-components';
import { LOCAL_WIDGET_ID, WidgetTokenProvider } from '@elfsight/lib-utils';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  WidgetFontsLoader
} from '@elfsight/widget-ui';
import { CacheProvider } from '@elfsight/widget-utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useSettings } from '@wu/widget-core';
import { camelCase } from 'es-toolkit';
import {
  CustomMetadataFetchersProvider,
  Layout,
  PlayerProvider,
  SourceProvider,
  ThemeProvider,
  VolumeProvider,
  WidthProvider
} from './components';
import { API_SCHEMA, meta } from './constants';

const { alias, name } = meta;
const queryClient = new QueryClient({});

export function AudioPlayer() {
  const {
    font,
    customJS,
    renderThumbnailMode,
    editMode,
    customCSS,
    widgetId,
    widgetToken
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    alias,
    widgetId
  );

  useDefineAPISchema(API_SCHEMA);
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <WidgetTokenProvider
      widgetId={widgetId || LOCAL_WIDGET_ID}
      widgetToken={widgetToken}
    >
      <QueryClientProvider client={queryClient}>
        <CacheProvider prefix={camelCase(name)}>
          <CustomCSS
            customCSS={customCSS}
            prefixClassName={customCSSPrefixClassName}
          />

          <WidthProvider className={customCSSPrefixClassName}>
            <ThemeProvider>
              <CustomMetadataFetchersProvider>
                <SourceProvider>
                  <PlayerProvider>
                    <VolumeProvider>
                      <Component>
                        <WidgetFontsLoader fonts={[font]} />
                        <Layout />
                      </Component>
                    </VolumeProvider>
                  </PlayerProvider>
                </SourceProvider>
              </CustomMetadataFetchersProvider>
            </ThemeProvider>
          </WidthProvider>
        </CacheProvider>
      </QueryClientProvider>
    </WidgetTokenProvider>
  );
}

const Component = styled.div`
  position: relative;
  ${'' /* Necessary to resolve the conflict with Shopify */}
  & div:empty {
    display: block;
  }
`;
